import React from 'react';

export default function SummaryScreen({ 
  totalItems, 
  completedCount, 
  duration, 
  onUseSameList, 
  onStartFresh 
}) {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const percentage = totalItems > 0 ? Math.round((completedCount / totalItems) * 100) : 0;

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-8">
      <div className="text-center max-w-2xl">
        <h2 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 text-transparent bg-clip-text">
          Speech Complete!
        </h2>

        <div className="flex justify-center gap-12 mb-8">
          <div className="text-center">
            <div className="text-5xl font-bold text-green-500 mb-2">
              {completedCount}/{totalItems}
            </div>
            <div className="text-gray-400">Points Covered</div>
            <div className="text-2xl text-gray-500 mt-2">
              {percentage}%
            </div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold text-purple-500 mb-2">
              {formatTime(duration)}
            </div>
            <div className="text-gray-400">Duration</div>
          </div>
        </div>

        {completedCount < totalItems && (
          <div className="bg-yellow-900/30 border border-yellow-700 rounded-xl p-4 mb-8">
            <p className="text-yellow-300">
              You missed {totalItems - completedCount} point{totalItems - completedCount !== 1 ? 's' : ''}
            </p>
          </div>
        )}

        {completedCount === totalItems && (
          <div className="bg-green-900/30 border border-green-700 rounded-xl p-4 mb-8">
            <p className="text-green-300 font-semibold">
              Perfect! You covered all your key points!
            </p>
          </div>
        )}

        <div className="space-y-4">
          <button
            onClick={onUseSameList}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 py-4 rounded-xl text-lg font-bold hover:from-purple-700 hover:to-pink-700 transition"
          >
            Use Same List Again
          </button>
          <button
            onClick={onStartFresh}
            className="w-full bg-gray-700 py-4 rounded-xl text-lg font-semibold hover:bg-gray-600 transition"
          >
            Start Fresh
          </button>
        </div>
      </div>
    </div>
  );
}